import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Globle } from 'src/assets/globle';
import { Category } from '../../category/category.model';
import { CategoryService } from '../../category/category.service';
import { SubCategory } from '../subCategory.model';
import { SubcategoryService } from '../subcategory.service';

@Component({
  selector: 'app-subcategorylst',
  templateUrl: './subcategorylst.component.html',
  styleUrls: ['./subcategorylst.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class SubcategorylstComponent implements OnInit {

  //#region variables
  Categories: Category[] = [];
  subCategories: SubCategory[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', 'imageUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<SubCategory>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('catgSearch') catgSearch: any
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  subCategory: SubCategory = {} as SubCategory;
  subCatgstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  selectedCategory: any
  filteredOptions!: Observable<Category[]>;
  searchCategory = new FormControl();
  language!: number;
  directCharge = false;
  imagPath: any;
  pageSize = 100;
  //#endregion

  constructor(private service: SubcategoryService,
    private categoryService: CategoryService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private translate: TranslateService,
    private globle: Globle,
    private storage: SessionStorageService) { }

  ngOnInit() {
    this.subCatgstatus = [{ id: 1, name: this.translate.instant("active") }, { id: 0, name: this.translate.instant("notActive") }];
    this.selectedStatus = 1;
    this.language = this.localStorage.retrieve("lang");
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
    this.searchCategory.markAsTouched();
    let category = this.storage.retrieve("categorySearch");
    if (category != null && category != undefined) {
      this.searchCategory.setValue(category);
      this.selectCatChange(category);
    }
  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(this.selectedStatus, this.directCharge).subscribe(data => {
      this.Categories = data
      this.autoCompleatFilter();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.Categories.slice())
      );
  }

  private _filter(name: string): Category[] {
    const filterValue = name.toLowerCase();

    return this.Categories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(category: Category): string {
    return category && category.arabicName ? category.arabicName : '';
  }

  getSubCategory() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedCategory, this.selectedStatus).subscribe(data => {
      this.subCategories = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.subCategories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/cards/addsubcategory']);
  }

  edit(id: number) {
    this.router.navigate(['./master/cards/editsubcategory/' + id]);
  }

  onDelete(id: number) {
    this.subCategory.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.subCategory.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getSubCategory();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectStatusChange() {
    this.getSubCategory();
  }

  selectCatChange(value: any) {
    this.selectedCategory = value.id;
    this.storage.store("categorySearch", value);
    this.getSubCategory();
  }
}
